
/**
 * This class should hold all the page related information
 */
export default class Page {
  public country    : string;
  public language   : string;
  public locale     : `${string}-${string}`;
  public name       : string;
  public queryParams: URLSearchParams;
  public environment: 'dev' | 'stage' | 'prod';

  constructor(locale: `${string}-${string}`, name: string, environment: 'dev' | 'stage' | 'prod') {
    this.locale = locale;
    this.name = name;
    this.environment = environment;
    this.country = this.locale.split('-')[1];
    this.language = this.locale.split('-')[0];
    this.queryParams = this.getQueryParams();
  }

  private getQueryParams(): URLSearchParams {
    return new URLSearchParams(window.location.search);
  }

  public getParamValue(key: string) {
    return this.queryParams.get(key);
  }
}